import { Button, Divider, Form, Input, Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';

import LoadingSpin from '@/components/UI/LoadingSpin';
import { ProgramScheduleModal } from '@/components/UI/ProgramScheduleModal';

import { PROGRAM_NAME_OPTIONS } from '../constants';
import { PaymentModal } from './components/PaymentModal';
import { ProgramDetail } from './components/ProgramDetail';
import { DUMMY_PROGRAM_DETAIL } from './constants';
import styles from './index.module.scss';

const { Item, useForm, useWatch } = Form;

const modalBodyStyles: React.CSSProperties = {
  maxHeight: '92vh',
  overflowY: 'auto',
};

type ProgramFormValues = {
  phoneNumber: string;
  program: string;
};

type AddOrderModalProps = {
  open: boolean;
  closeModal: () => void;
};

export const AddOrderModal = ({ open, closeModal }: AddOrderModalProps) => {
  const [form] = useForm<ProgramFormValues>();
  const watchPhoneNumber = useWatch('phoneNumber', form);

  const [shouldShowContent, setShouldShowContent] = useState(true); // TODO: 測試用狀態，記得刪除
  const [isProgramDetailLoading, setIsProgramDetailLoading] = useState(false); // TODO: 測試用狀態，記得刪除，並改用swr提供的isLoading

  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [isProgramScheduleLoading, setIsProgramScheduleLoading] =
    useState(false); // TODO: 測試用狀態，記得刪除，並改用swr提供的isLoading

  const [selectedMemberAmount, setSelectedMemberAmount] = useState(0);
  const [selectedNonMemberAmount, setSelectedNonMemberAmount] = useState(0);

  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [isMemberPointInfoLoading, setIsMemberPointInfoLoading] =
    useState(false); // TODO: 測試用狀態，記得刪除，並改用swr提供的isLoading

  const handleProgramFormFinish = (formValues: ProgramFormValues) => {
    console.log('formValues:', formValues);

    // TODO: 這邊要打API去獲取育樂活動資訊，邏輯待寫
    setIsProgramDetailLoading(true);
    setTimeout(() => {
      setShouldShowContent(true);
      setIsProgramDetailLoading(false);
    }, 1500);
  };

  const openScheduleModal = () => {
    // TODO: 這邊要打API去獲取育樂活動時程資訊，邏輯待寫
    setShowScheduleModal(true);
    setIsProgramScheduleLoading(true);

    setTimeout(() => {
      setIsProgramScheduleLoading(false);
    }, 1500);
  };

  useEffect(() => {
    if (!open) {
      form.resetFields();
      setShouldShowContent(false);
    }
  }, [form, open]);

  const handleAmountChange = (type: 'member' | 'nonMember', amount: number) => {
    if (type === 'member') {
      setSelectedMemberAmount(amount);
    }
    if (type === 'nonMember') {
      setSelectedNonMemberAmount(amount);
    }
  };

  const openPaymentModal = () => {
    if (selectedMemberAmount <= 0 && selectedNonMemberAmount <= 0) {
      return;
    }
    // TODO: 這邊要打API去獲取用戶點數資訊，邏輯待寫
    setShowPaymentModal(true);
    setIsMemberPointInfoLoading(true);

    setTimeout(() => {
      setIsMemberPointInfoLoading(false);
    }, 1500);
  };

  const shouldDisableField = shouldShowContent || isProgramDetailLoading;

  return (
    <Modal
      centered
      destroyOnClose
      open={open}
      onCancel={closeModal}
      bodyStyle={modalBodyStyles}
      maskClosable={false}
      footer={null}
    >
      <Form
        form={form}
        className={styles.form}
        layout="vertical"
        onFinish={handleProgramFormFinish}
      >
        <Item
          label="會員手機號碼"
          name="phoneNumber"
          rules={[{ required: true, message: '必填欄位' }]}
        >
          <Input
            placeholder="例如: 0987654321"
            type="tel"
            disabled={shouldDisableField}
          />
        </Item>

        <Item
          label="育樂活動"
          tooltip="需先輸入手機號碼後才能選擇"
          name="program"
          rules={[{ required: true, message: '必填欄位' }]}
        >
          <Select
            allowClear
            showSearch
            disabled={!watchPhoneNumber || shouldDisableField}
            placeholder="請選擇或輸入育樂活動名稱"
            optionFilterProp="label"
            className={styles.filter}
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            options={PROGRAM_NAME_OPTIONS}
            onSelect={() => form.submit()}
          />
        </Item>
      </Form>

      {isProgramDetailLoading && <LoadingSpin />}

      {shouldShowContent && (
        <>
          <div className={styles.contentContainer}>
            <ProgramDetail
              program={DUMMY_PROGRAM_DETAIL} // TODO: 這裡測試用資料，記得改用API獲取的實際資料
              showProgramSchedule={openScheduleModal}
              amountOptions={{
                memberMaxSelectableAmount: 10,
                nonMemberMaxSelectableAmount: 8,
                onAmountChange: handleAmountChange,
              }}
            />
            <Divider />
            <div className={styles.footerButton}>
              <Button
                onClick={openPaymentModal}
                disabled={
                  selectedMemberAmount <= 0 && selectedNonMemberAmount <= 0
                }
              >
                前往付款
              </Button>
            </div>
          </div>

          <ProgramScheduleModal
            open={showScheduleModal}
            closeModal={() => setShowScheduleModal(false)}
            schedule={{
              fixedSchedule: DUMMY_PROGRAM_DETAIL.fixedSchedule,
              nonFixedSchedule: DUMMY_PROGRAM_DETAIL.nonFixedSchedule,
            }}
          />

          <PaymentModal
            open={showPaymentModal}
            closeModal={() => setShowPaymentModal(false)}
            paymentInfo={{
              pricing: DUMMY_PROGRAM_DETAIL.pricing,
              memberAmount: selectedMemberAmount,
              nonMemberAmount: selectedNonMemberAmount,
            }}
            currentMemberPoint={12500} // TODO: 測試用數值，記得改用API獲取的實際點數值
          />
        </>
      )}
    </Modal>
  );
};
